import React, { useState } from "react";
import { useSelector } from "react-redux";
import { downloadCSV, downloadPaylocityCSV } from "../apiCalls/userApiCalls";
import moment from "moment";
import WeekSelector from "../components/WeekSelector";

export default function DownloadCSV() {
  const [week, setWeek] = useState(moment().isoWeek());
  const [year, setYear] = useState(moment().isoWeekYear());
  const [exportFormat, setExportFormat] = useState("standard");
  const [isDownloading, setIsDownloading] = useState(false);

  const { currentUser } = useSelector((state) => state.userSlice) || null;
  const token = currentUser.token;

  function handleWeekChange({ week, year }) {
    setWeek(week);
    setYear(year);
  }

  async function handleDownload() {
    setIsDownloading(true);
    try {
      if (exportFormat === "paylocity") {
        await downloadPaylocityCSV(week, year, token);
      } else {
        await downloadCSV(week, year, token);
      }
    } finally {
      setIsDownloading(false);
    }
  }

  return (
    <>
      <div className="flex flex-col justify-center mt-32 px-24">
        <WeekSelector week={week} year={year} onWeekChange={handleWeekChange} />

        <div className="flex justify-center mt-6">
          <div className="bg-white rounded-lg shadow p-4 w-full max-w-md">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Export Format
            </label>
            <select
              value={exportFormat}
              onChange={(e) => setExportFormat(e.target.value)}
              disabled={isDownloading}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="standard">Standard Payroll CSV</option>
              <option value="paylocity">Punch Import</option>
            </select>
            <p className="mt-2 text-xs text-gray-500">
              {exportFormat === "paylocity"
                ? "Generates punch records (In/Out), NRH entries, and bonuses in time punch format"
                : "Standard payroll export with hours and pay calculations"
              }
            </p>
          </div>
        </div>

        <div className="text-center mt-4">
          <button
            className={`px-4 py-1 text-sm font-medium rounded-md border-none text-white min-w-[140px] ${
              isDownloading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#59c3c2] hover:bg-teal-600"
            }`}
            onClick={handleDownload}
            disabled={isDownloading}
          >
            {isDownloading ? (
              <span className="inline-flex items-center">
                Downloading
                <span className="ml-1 animate-pulse">.</span>
                <span className="animate-pulse" style={{ animationDelay: "0.2s" }}>.</span>
                <span className="animate-pulse" style={{ animationDelay: "0.4s" }}>.</span>
              </span>
            ) : (
              "Download CSV"
            )}
          </button>
        </div>
      </div>
    </>
  );
}
